<template>
  <v-container>
    <v-layout row wrap>
      <!-- <v-flex xs12 md6> -->
      <!-- <v-select
          name="broker"
          v-bind:label="$t('message.broker')"
          v-validate="'required'"
          :error-messages="errors.collect('broker')"
          single-line
          :items="broker"
          v-model="e3Broker"
      ></v-select>-->
      <!--    <v-autocomplete
          :items="broker"
          :filter="customFilter"
          color="white"
          item-text="Descripcion"
          item-value="IdApsSos"
          name="broker"
          v-bind:label="$t('message.aps')"
          v-validate="'required'"
          :error-messages="errors.collect('broker')"
          v-model="e3Broker"
        ></v-autocomplete>
      </v-flex>-->
      <v-flex xs12 md6>
        <v-select name="yearCommercial" v-bind:label="$t('message.yearCommercial')" v-validate="'required'"
          :error-messages="errors.collect('yearCommercial')" item-text="Valor" :items="yearCommercial"
          v-model="e6yearCommercial"></v-select>
      </v-flex>

      <v-flex xs12 md6>
        <v-select name="indicator" v-bind:label="$t('message.indicator')" v-validate="'required'"
          :error-messages="errors.collect('indicator')" item-text="value" item-value="code" :items="catalogIndicators"
          v-model="e1Indicator"></v-select>
      </v-flex>

      <v-flex xs12 md6>
        <v-select name="startWeek" v-bind:label="$t('message.startWeek')" v-validate="'required'"
          :error-messages="errors.collect('startWeek')" item-text="Valor" :items="startWeek"
          v-model="e4startWeek"></v-select>
      </v-flex>

      <v-flex xs12 md6>
        <v-select name="endWeek" v-bind:label="$t('message.endWeek')" v-validate="'required'"
          :error-messages="errors.collect('endWeek')" item-text="Valor" :items="endWeek" v-model="e5endWeek"></v-select>
      </v-flex>

      <v-flex xs12 md6>
        <!-- <v-select
          name="branchOffices"
          v-bind:label="$t('message.branchOffices')"
          v-validate="'required'"
          :error-messages="errors.collect('branchOffices')"
          item-text="NombreAgencia"
          item-value="IdAgencia"
          :items="branchOffices"
          v-model="e2BranchOffices"
        ></v-select>-->
        <label style="color: rgb(149, 149, 149);!important;font-size: 16px;
              line-height: 1;
              min-height: 8px;font-weight: 400;">Sucursales</label>
        <v-radio-group name="branchOffices" v-validate="'required'" :error-messages="errors.collect('branchOffices')"
          v-model="branchOffices" :mandatory="false">
          <v-radio label="Todas" value="0"></v-radio>
          <v-radio label="Sucursal Actual" value="1"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-flex v-if="showGraphic" class="row">
      <v-flex class="md8 lg8" offset-md2 offset-lg2>
        <chart-weekly-budget-compliance :chartData="datasets" :options="options"></chart-weekly-budget-compliance>
      </v-flex>
    </v-flex>
    <v-flex class="row pt-4">
      <h3 class="subheading text--secondary">{{ $t('message.tableAccidentRate') }}</h3>
      <v-layout>
        <v-flex text-lg-left>
          <v-btn class="ml-0" flat icon color="primary" v-on:click="refresh">
            <v-icon>cached</v-icon>
          </v-btn>
        </v-flex>
        <v-flex text-lg-right>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-flex>
      </v-layout>
      <v-data-table :items="table1" :headers="headerAccidentRate" class="v-table-list theme--light" :search="search">
        <template slot="items" scope="props">
          <tr :active="props.selected" @click="props.selected = !props.selected">
            <td class="text-xs-left cut-text">{{ props.item.Column1 }}</td>
            <td class="text-xs-left cut-text">$ {{ props.item.Column2 }}</td>
            <td class="text-xs-left cut-text">$ {{ props.item.Column3 }}</td>
            <td class="text-xs-left cut-text">$ {{ props.item.Column4 }}</td>
            <td class="text-xs-left cut-text">{{ props.item.Column5 }}%</td>
          </tr>
        </template>
        <template slot="no-data">
          <div>{{ $t('message.noRecords') }}</div>
        </template>
        <template slot="pageText" slot-scope="props">{{ props.pageStart }} - {{ props.pageStop }} {{ $t('message.of') }}
          {{ props.itemsLength }}</template>
      </v-data-table>
    </v-flex>
  </v-container>
</template>


<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import router from "@/router";

import DatePicker from "@/components/DatePicker/DatePicker";

import ChartWeeklyBudgetCompliance from "./ChartWeeklyBudgetCompliance.vue";

import { EventBus } from "@/imports/EventBus";

import CatalogServices from "@/services/CatalogsServices";
import ComunServices from "@/services/ComunServices";

import CommercialGraphicsServices from "@/services/CommercialGraphicsServices";

export default {
  components: {
    ChartWeeklyBudgetCompliance,
    DatePicker
  },
  computed: {
    ...mapGetters(["agency", "userProfile", "agencyId"])
  },
  beforeDestroy() {
    EventBus.$off("AccidentRate");
  },
  mounted() {
    this.getCatalogInfo();
    EventBus.$on("AccidentRate", () => {
      this.$validator.validateAll().then(success => {
        if (success) {
          this.$nextTick(() => {
            this.getDataFromApi();
          });
          /* this.showGraphic=true
            this.table1=analysisJSONTest.Data.Tabla1
          */
        }
      });
    });
  },
  methods: {
    nzDate: nzDate,
    getCatalogInfo() {
      /*  ComunServices.getAgencies()
        .then(response => {
          this.branchOffices = response.data.data.Data;
        })
        .catch(res => {
          this.$root.$emit(
            "showSnackBar",
            "No se ha podido cargar las sucursales",
            "error"
          );
        });
      ComunServices.getAgents()
        .then(response => {
          this.broker = response.data.data.Data;
        })
        .catch(res => {
          this.$root.$emit(
            "showSnackBar",
            "No se ha podido cargar APS",
            "error"
          );
        }); */
      CatalogServices.getIndicators()
        .then(response => {
          this.catalogIndicators = response.data.data;
        })
        .catch(res => {
          this.$root.$emit("showSnackBar", "Error desconocido", "error");
        });
    },
    refresh() {
      this.$validator.validateAll().then(success => {
        if (success) {
          this.$nextTick(() => {
            this.showGraphic = false;
            this.table1 = [];
            this.getDataFromApi();
          });
        }
      });
    },
    getDataFromApi() {
      this.table1 = [];
      this.$root.$emit(
        "showLoading",
        "Cargando cumplimiento semanal de presupuesto"
      );
      let agencyId = "";
      if (this.branchOffices == "1") {
        agencyId = this.agencyId;
      } else {
        agencyId = 0;
      }
      this.e3Broker = this.userProfile.id_aps_vt;

      CommercialGraphicsServices.getSinistralityGraphic(
        this.e3Broker,
        this.e6yearCommercial,
        this.e4startWeek,
        this.e5endWeek,
        this.e1Indicator,
        agencyId
        /* this.e2BranchOffices */
      ).then(res => {
        this.$nextTick(() => {
          let dataResponse = res.data.data.Data;
          if (
            typeof res.data.data.Error != undefined &&
            res.data.data.Data == null
          ) {
            this.$root.$emit("hideLoading");
            this.$root.$emit("showSnackBar", res.data.data.Msg, "error");
          }
          if (typeof dataResponse != "undefined") {
            if (dataResponse.Grafico[0] != null && res.data.data.Data != null) {
              this.labels = this.getLabelsFromTable(dataResponse.Tabla1);
              this.dataFromGraphic = [
                {
                  label: dataResponse.Grafico[0].Label,
                  borderColor: "#0695e8",
                  pointBackgroundColor: "white",
                  borderWidth: 1,
                  pointBorderColor: "#0695e8",
                  backgroundColor: "rgba(6, 150, 234, 0.5)",
                  data: dataResponse.Grafico[0].Data
                },
                {
                  label: dataResponse.Grafico[1].Label,
                  borderColor: "#4906e8",
                  yAxisID: "A",
                  pointBackgroundColor: "white",
                  pointBorderColor: "#4906e8",
                  borderWidth: 1,
                  backgroundColor: "rgba(74, 6, 234, 0.5)",
                  data: dataResponse.Grafico[1].Data
                },
                {
                  label: dataResponse.Grafico[2].Label,
                  borderColor: "#d60808",
                  yAxisID: "B",
                  pointBackgroundColor: "white",
                  pointBorderColor: "#d60808",
                  borderWidth: 1,
                  backgroundColor: "rgba(217, 8, 8, 0.2)",
                  data: dataResponse.Grafico[2].Data
                }
              ];

              let el = this;
              this.xAxes = [
                {
                  scaleLabel: {
                    display: true,
                    labelString: "Semana",
                    fontFamily: "Roboto",
                    fontSize: 14
                  }
                }
              ];

              this.yAxes = [
                {
                  id: "A",
                  type: "linear",
                  position: "left",
                  ticks: {
                    stepSize: 5000000,
                    callback: function (value) {
                      var ranges = [
                        { divider: 1e6, suffix: "M" },
                        { divider: 1e3, suffix: "k" }
                      ];
                      function formatNumber(n) {
                        for (var i = 0; i < ranges.length; i++) {
                          if (n >= ranges[i].divider) {
                            return (
                              (n / ranges[i].divider).toString() +
                              ranges[i].suffix
                            );
                          }
                        }
                        return n;
                      }
                      return "$ " + formatNumber(value);
                    }
                  },
                  layout: {
                    padding: {
                      left: 10
                    }
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "Valor",
                    fontFamily: "Roboto",
                    fontSize: 14
                  }
                },
                {
                  id: "B",
                  type: "linear",
                  position: "right",
                  ticks: {
                    callback: function (value, index, values) {
                      return value + " %";
                    },
                    max: 100,
                    min: 0
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "Siniestralidad",
                    fontFamily: "Roboto",
                    fontSize: 14
                  }
                }
              ];
              let restrictsTable = { Semana: "Semana" };
              this.table1 = dataResponse.Tabla1;
              this.setFormatTable(this.table1, restrictsTable);
              /*



             */

              this.options = {
                responsive: true,
                maintainAspectRatios: false,
                scales: {
                  yAxes: this.yAxes,
                  xAxes: this.xAxes
                },
                tooltips: {
                  mode: "index",
                  fontFamily: "Roboto",
                  callbacks: {
                    title: function (tooltipItem, data) {
                      return (
                        el.xAxes[0].scaleLabel.labelString +
                        " : " +
                        data.labels[tooltipItem[0].index]
                      );
                    },

                    label: function (tooltipItem, data) {
                      return (
                        data.datasets[tooltipItem.datasetIndex].label +
                        ":" +
                        tooltipItem.yLabel.toLocaleString()
                      );
                    }
                  }
                }
              };
              this.datasets = {
                labels: this.labels,
                datasets: this.dataFromGraphic
              };
              this.showGraphic = true;
              this.$root.$emit("hideLoading");
            } else {
              this.$root.$emit("hideLoading");
              this.$root.$emit(
                "showSnackBar",
                "No hay datos que mostrar",
                "accent"
              );

              this.table1 = [];
            }
          }
        });
      });
    },
    getLabelsFromTable(table) {
      let labels = [];
      for (let i = 0; i < table.length; i++) {
        labels.push(table[i].Semana);
      }
      return labels;
    },
    setFormatNumber(num, symbol) {
      let separator = ".";
      let sepDecimal = ",";
      num += "";
      var splitStr = num.split(".");
      var splitLeft = splitStr[0];
      var splitRight = splitStr.length > 1 ? sepDecimal + splitStr[1] : "";
      var regx = /(\d+)(\d{3})/;
      while (regx.test(splitLeft)) {
        splitLeft = splitLeft.replace(regx, "$1" + separator + "$2");
      }
      return symbol + splitLeft + splitRight;
    },

    setFormatTable(table, restricts) {
      let cont = 0;
      table.forEach(element => {
        for (var property in element) {
          if (property != " " && typeof restricts[property] == "undefined") {
            let str = element[property];
            str = str.replace(",", ".");
            str = this.setFormatNumber(str, "");
            table[cont][property] = str;
          }
        }
        cont++;
      });
    },
    customFilter(item, queryText, itemText) {
      if (item.Descripcion != null && item.IdApsSos != null) {
        const textOne = item.Descripcion.toLowerCase();
        const textTwo = item.IdApsSos.toLowerCase();
        const searchText = queryText.toLowerCase();

        return (
          textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
        );
      }
    }
  },
  watch: {},
  data() {
    return {
      yAxes: [],
      xAxes: [],
      dataFromGraphic: [],
      search: "",
      catalogIndicators: [],
      showGraphic: false,
      e3Broker: null,
      broker: [],
      selected: [],
      catalogTypeOfProduction: [],
      pagination: {},
      yearCommercial: [
        "2012",
        "2013",
        "2014",
        "2015",
        "2016",
        "2017",
        "2018",
        "2019",
        "2020",
        "2021",
        "2022",
        "2023",
        "2024",
        "2025",
        "2026",
        "2027",
        "2028",
        "2029",
        "2030",
        "2031",
        "2032",
        "2033",
        "2034",
        "2035",
        "2036",
        "2037",
        "2038",
        "2039",
        "2040",
        "2041",
        "2042",
        "2043",
        "2044",
        "2045",
        "2046",
        "2047",
        "2048",
        "2049",
        "2050"
      ],
      e1Indicator: null,
      e2BranchOffices: null,
      typeProduction: [],
      branchOffices: "",
      e4startWeek: null,
      e5endWeek: null,
      e6yearCommercial: null,
      startWeek: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "51",
        "52"
      ],
      endWeek: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "51",
        "52"
      ],
      table1: [],
      accidentRate: [],
      searchValue: "",
      headerAccidentRate: [
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.week"),
          value: "Semana",
          width: "14%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.accumulatedQualifiedPremium"),
          value: "Prima",
          width: "14%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.accumulatedPaidLosses"),
          value: "Siniestros",
          width: "14%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.difference"),
          value: "Diferencia",
          width: "14%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.accidentRate"),
          value: "Porcentaje",
          width: "14%"
        }
      ]
    };
  }
};
</script>